import { useMutation } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import { FlyError, Link, Text, useToast } from "@wayflyer/flyui";
import type { AxiosError } from "axios";
import { useIntl } from "react-intl";
import { handleContactTeam } from "shared-utils";

import { useErrorModal } from "../../error-handling/app-error-modal-provider";
//TODO: move this to a product request endpoint
import { useOfferRequestPath } from "../../offers/hooks";

import { INTL_MESSAGES } from "./defined-messages";

export const useSendDealOwnerMessageMutation = (
  dealOwnerName: string,
  handleClose: () => void,
  productRequestId: string,
  customerDomain: string
) => {
  const intl = useIntl();
  const toaster = useToast();
  const client = useAxios();
  const requestPath = useOfferRequestPath().getDealOwner(productRequestId);
  const { openErrorModal, closeErrorModal } = useErrorModal();

  return useMutation({
    mutationKey: ["sendDealOwnerMessage"],
    mutationFn: (params: { message: string }) => client.post(requestPath, params),
    onSuccess: () => {
      handleClose();
      toaster.positive(
        `${intl.formatMessage(INTL_MESSAGES.contactFormSuccessMessageHeader)} ${intl.formatMessage(
          INTL_MESSAGES.dealOwnerContactFormSuccessMessageBody,
          { name: dealOwnerName }
        )}`
      );
    },
    onError: (error: AxiosError) => {
      handleClose();
      openErrorModal(
        new FlyError({
          title: intl.formatMessage({
            id: "Error sending deal owner message title",
            defaultMessage: "There was an error sending your message",
          }),
          error: new Error(`Failed to send a message to the deal owner for customer: ${customerDomain}`, {
            cause: error,
          }),
          message: intl.formatMessage(
            {
              id: "Error sending deal owner message body",
              defaultMessage:
                "<p>Sorry, there was an error while sending this message. If the error persists, please <a>contact our support team</a>.</p>",
            },
            {
              p: (chunks) => <Text>{chunks}</Text>,
              a: (chunks) => (
                <Link
                  onClick={() => {
                    closeErrorModal();
                    handleContactTeam();
                  }}
                >
                  {chunks}
                </Link>
              ),
            }
          ),
        })
      );
    },
  });
};
